"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieRemove = exports.cookieGet = exports.cookieSave = exports.localStorageRemove = exports.localStorageGet = exports.localStorageSave = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const localStorageSave = (key, object) => {
    if (typeof object === "string") {
        localStorage.setItem(key, object);
    }
    return object;
};
exports.localStorageSave = localStorageSave;
const localStorageGet = (key) => localStorage.getItem(key);
exports.localStorageGet = localStorageGet;
const localStorageRemove = (key) => {
    localStorage.removeItem(key);
};
exports.localStorageRemove = localStorageRemove;
const cookieSave = (key, object, expires = 30) => {
    if (typeof object === "string") {
        js_cookie_1.default.set(key, object, { expires: expires });
    }
    return object;
};
exports.cookieSave = cookieSave;
const cookieGet = (key) => js_cookie_1.default.get(key);
exports.cookieGet = cookieGet;
const cookieRemove = (key) => js_cookie_1.default.remove(key);
exports.cookieRemove = cookieRemove;
